// A short, attention-grabbing three-tone chime for new live-chat notifications
// (Web Audio, no asset needed). Louder + longer so it's noticeable across tabs.
export function playChime() {
    try {
        const Ctx = window.AudioContext || window.webkitAudioContext;
        const ctx = new Ctx();
        const now = ctx.currentTime;
        [880, 1320, 1760].forEach((freq, idx) => {
            const osc = ctx.createOscillator();
            const gain = ctx.createGain();
            osc.type = "sine";
            osc.frequency.value = freq;
            const start = now + idx * 0.16;
            gain.gain.setValueAtTime(0.0001, start);
            gain.gain.exponentialRampToValueAtTime(0.7, start + 0.02);
            gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.28);
            osc.connect(gain);
            gain.connect(ctx.destination);
            osc.start(start);
            osc.stop(start + 0.3);
        });
        setTimeout(() => ctx.close(), 1200);
    } catch (e) {
        /* audio not available */
    }
}
